import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { DocumentLinkDisplayModalComponent } from '../../../document-links/components/document-link-display-modal/document-link-display-modal.component';
import { DocumentLinkTypeEnum } from '../../enums/document-type.enum';
import { KnowHowDocumentsCategoryModel } from '../../models/documents/know-how-documents-category.model';
import { KnowHowDocumentsDocumentModel } from '../../models/documents/know-how-documents-document.model';
import { KnowHowService } from '../../services/know-how.service';

@Component({
    selector: 'app-know-how-document-category-list',
    templateUrl: './know-how-document-category-list.component.html',
    styleUrl: './know-how-document-category-list.component.scss'
})
export class KnowHowDocumentCategoryListComponent {
    @Input({ required: true }) sportName!: string;
    @Input({ required: true }) categories!: KnowHowDocumentsCategoryModel[];

    constructor(
        private bsModalService: BsModalService,
        private knowHowService: KnowHowService
    ) { }

    protected documentLinkTypeEnum = DocumentLinkTypeEnum;

    protected openDocument(document: KnowHowDocumentsDocumentModel): void {
        if (document.type == DocumentLinkTypeEnum.Link) this.openLinkType(document);
        if (document.type == DocumentLinkTypeEnum.Document) this.openDocumentType(document);
    }

    protected openLinkType(document: KnowHowDocumentsDocumentModel): void {
        if (!document.isReadByUser) this.markLinkAsRead(document.documentId);
        if (document.linkUrl == null) return;
        const sanitizedUrl = encodeURI(document.linkUrl);
        window.open(sanitizedUrl, '_blank');
    }

    protected openDocumentType(document: KnowHowDocumentsDocumentModel): void {
        this.openModal(document);
    }

    protected openModal(document: KnowHowDocumentsDocumentModel): void {
        let ref = this.bsModalService.show(DocumentLinkDisplayModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                name: document.name,
                documentId: document.documentId,
                linkUrl: document.linkUrl,
                type: document.type,
                acceptanceDeadlineUtc: document.acceptanceDeadlineUtc,
                isReadByUser: document.isReadByUser
            }
        });

        ref.content!.onDocumentRead.subscribe(x => {
            this.updateReadStatus(document.documentId);
        });
    }

    private markLinkAsRead(documentId: string): void {
        this.knowHowService.markDocumentAsRead(documentId).subscribe({
            next: () => {
                this.updateReadStatus(documentId);
            }
        });
    }

    private updateReadStatus(documentId: string): void {
        this.categories.forEach(d => {
            let doc = d.documents.find(x => x.documentId == documentId);
            if (doc != null) doc.isReadByUser = true;
        });
    }
}
